var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.5H9C6.51472 4.5 4.5 6.51472 4.5 9V18C4.5 20.4852 6.51472 22.5 9 22.5H18C20.4852 22.5 22.5 20.4852 22.5 18V9C22.5 6.51472 20.4852 4.5 18 4.5ZM9 2.25C5.27208 2.25 2.25 5.27208 2.25 9V18C2.25 21.7279 5.27208 24.75 9 24.75H18C21.7279 24.75 24.75 21.7279 24.75 18V9C24.75 5.27208 21.7279 2.25 18 2.25H9Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 9C19.7463 9 20.25 8.49632 20.25 7.875C20.25 7.25368 19.7463 6.75 19.125 6.75C18.5037 6.75 18 7.25368 18 7.875C18 8.49632 18.5037 9 19.125 9Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.125 13.5C19.125 16.6066 16.6066 19.125 13.5 19.125C10.3934 19.125 7.875 16.6066 7.875 13.5C7.875 10.3934 10.3934 7.875 13.5 7.875C16.6066 7.875 19.125 10.3934 19.125 13.5ZM16.875 13.5C16.875 15.364 15.364 16.875 13.5 16.875C11.636 16.875 10.125 15.364 10.125 13.5C10.125 11.636 11.636 10.125 13.5 10.125C15.364 10.125 16.875 11.636 16.875 13.5Z",
    fill: "#777E91"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.56970d43f062b914c3b4518b0659bfa5.svg";
export { ForwardRef as ReactComponent };